// extracted by mini-css-extract-plugin
export var cancelButton = "_mz-5";
export var content = "_mz-3";
export var createButton = "_mz-6";
export var drawerContainer = "_mz-0";
export var footer = "_mz-2";
export var header = "_mz-1";
export var orderFormColumn = "_mz-4";